import React from "react";
import { ContactData } from "../data-types/api-client/api-contacts";

interface ContactProps {
  contact: ContactData | undefined; // Accept ContactData as a prop
}

const PrivacyPolicyPage: React.FC<ContactProps> = ({ contact }) => {
  return (
    <div className="max-w-6xl mx-auto p-6 sm:px-8 sm:py-10 text-custom-atrament border-custom-gray-200 border">
      <p className="mb-0 leading-relaxed">
        <strong>Podmienky ochrany osobných údajov</strong>
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        Sme spoločnosť&nbsp;{contact?.contact.address.name},{" "}
        {`${contact?.contact.address.street} ${contact?.contact.address.number}, ${contact?.contact.address.psc} ${contact?.contact.address.village}.`}
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        Prevádzkujeme prenájom na webových stránkach&nbsp;
        <a href="https://www.rentkos.sk">
          <strong>www.rentkos.sk</strong>
        </a>
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        Pri poskytovaní našich&nbsp;služieb, požičovňa
        náradia&nbsp;a&nbsp;prevádzkovaní našich webových stránok spracúvame
        niektoré osobné údaje.
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        Spracúvanie osobných údajov upravuje najmä nariadenie Európskeho
        parlamentu a Rady (EÚ) 2016/679 z 27. apríla 2016 pri spracúvaní
        osobných údajov a&nbsp;o&nbsp;voľnom pohybe takýchto údajov, ktorým sa
        zrušuje 95/46/ES (všeobecné nariadenie o ochrane osobných údajov) („
        <strong>GDPR</strong>“).
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        <strong>1. Spracúvanie osobných údajov</strong>
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        <strong>
          I. Spracúvanie osobných údajov prostredníctvom kontaktné formulára
        </strong>
      </p>
      <p className="mb-0 leading-relaxed">
        V&nbsp;prípade Vášho záujmu o&nbsp;naše služby a&nbsp;Vášho oslovenia,
        budeme využívať Vaše osobné údaje (nie citlivé), ktoré nám sprístupníte
        cez náš kontaktný formulár alebo osobne pri prevzatí prenajímanej veci
        respektíve spisovaní ZoD. Sú to tieto údaje: Meno a&nbsp;priezvisko,
        adresa, telefónne číslo, e-mail, fyzických osobách. Názov, adresa, tel.
        číslo, e-mail pri právnických osobách.&nbsp;
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        <i>Odôvodnenie</i>
      </p>
      <p className="mb-0 leading-relaxed">
        Prostredníctvom Vami sprístupnených údajov Vás skontaktujeme pre
        realizáciu našich služieb.
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        <i>Právny rámec</i>
      </p>
      <p className="mb-0 leading-relaxed">
        Spracovávanie osobných a&nbsp;identifikačných údajov na základe článku
        6, odsek 1, písmeno b) GDPR -
      </p>
      <p className="mb-0 leading-relaxed">
        plnenie zmluvy, resp. vykonanie opatrení pred uzavretím zmluvy na Vašu
        žiadosť.&nbsp;
      </p>
      <p className="mb-0 leading-relaxed">
        Ak by nám tieto údaje z&nbsp;Vašej strany neboli poskytnuté, nemôžeme
        realizovať ďalšie kroky pre uzatvorenie nájomnej zmluvy resp. zmluvy
        o&nbsp;dielo.
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        <i>Doba spracovávania/uchovávania údajov</i>
      </p>
      <p className="mb-0 leading-relaxed">
        V&nbsp;prípade realizácie zmluvného vzťahu budem údaje uchovávať
        maximálne 60 mesiacov od ukončenia komunikácie
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        <strong>
          II. Spracúvanie osobných údajov - pre potreby nájomnej zmluvy, resp.
          ZoD
        </strong>
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        V&nbsp;prípade Vášho rozhodnutia o&nbsp;uzatvorení zmluvného vzťahu budú
        pre uzatvorenie zmluvy potrebné nasledujúce údaje:
      </p>
      <ol className="pt-4 list-decimal pl-6">
        <li className="mb-2">
          Fyzická osoba: Meno, Priezvisko, Titul, Adresa trvalého pobytu, číslo
          OP
        </li>
        <li className="mb-2">
          Právnická osoba: Názov, Právna forma, Sídlo, Fakturačné údaje, Bankové
          spojenie, identifikačné údaje štatutára (viď fyzická osoba)
        </li>
      </ol>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        <i>Odôvodnenie</i>
      </p>
      <p className="mb-0 leading-relaxed">
        Pre uzatvorenie zmluvného vzťahu je potrebné správne určenie
        odberateľa/prenajímateľa/objednávateľa. Tieto údaje budú spracovávane
        pre daňové, účtovné a&nbsp;právne účely.
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        <i>Právny rámec</i>
      </p>
      <p className="mb-0 leading-relaxed">
        Predmetné údaje sa spracovávajú na základe článku 6, odseku1, písmena b)
        GDPR - plnenie zmluvy. Článku 6, odseku 1, písmena c) GDPR - plnenie
        našej právnej povinnosti
      </p>
      <p className="mb-0 leading-relaxed">
        Ide o spracúvanie na základe článku 6 ods. 1 písm. b) GDPR - plnenie
        zmluvy a článok 6 ods. 1 písm. c) GDPR - plnenie našej právnej
        povinnosti.&nbsp;
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        <i>Doba spracovávanie údajov</i>
      </p>
      <p className="mb-0 leading-relaxed">
        Počas realizácie zmluvného vzťahu a&nbsp;následne maximálne po dobu 60
        mesiacov od ukončenia právneho vzťahu.&nbsp;
      </p>
      <p className="p2">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        <strong>
          III. Zasielanie informácií a používanie&nbsp;marketingových nástrojov
        </strong>
        &nbsp;
      </p>
      <p className="mb-0 leading-relaxed">
        V&nbsp;prípade, že ste využili naše služby a&nbsp;výslovne neuviedli, že
        si neželáte dostávať marketingové oznámenia, budeme Vašu e-mailovú
        adresu využívať na doručovanie našich informácii o&nbsp;novinkách
        prípadne akciách.
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        <i>Právny rámec</i>
      </p>
      <p className="mb-0 leading-relaxed">
        Článok 6, odsek 1, písmeno f) GDPR - naše oprávnené záujmy, ktorými sú
        marketingová komunikácii cielená na našich zákazníkov.
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        <i>Doba spracovávanie údajov</i>
      </p>
      <p className="mb-0 leading-relaxed">
        60 mesiacov od ukončenia posledného zmluvného vzťahu. V&nbsp;prípade
        nesúhlasu zo zasielaním našich nástrojov marketingového mix, môžete nám
        to oznámiť písomne na e-mail:&nbsp;
        <a href={`mailto:${contact?.contact.email}`}>
          <strong>{contact?.contact.email}</strong>
        </a>
        .
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        <strong>2. Prístup k&nbsp;nevyhnutným údajom - tretie osoby</strong>
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        Vaše osobné údaje zostanú u nás. Niektoré osobné údaje budú poskytnuté
        tretím osobám, ktoré sa podieľajú na našej činnosti a&nbsp;to len
        v&nbsp;nevyhnutnom rozsahu, aby boli zabezpečené daňové, účtovné
        a&nbsp;právne účely. Sú to:
      </p>
      <ol className="pt-4 list-decimal pl-6">
        <li className="mb-2">
          spoločnosti podieľajúce sa na expedícii tovaru (SPS)
        </li>
        <li className="mb-2">
          spoločnosti podieľajúce sa na expedícii platieb (SLSP, Tatrabanka)
        </li>
        <li className="mb-2">účtovnícka spoločnosť VH - účtovníctvo</li>
      </ol>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        Osobné údaje spracúvame iba na území Európskej únie.
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        <strong>3. Čo by ste ďalej mali vedieť</strong>
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        V našej spoločnosti&nbsp;máme&nbsp;zodpovednú osobu pre ochranu osobných
        údajov.
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        V našej spoločnosti&nbsp;nedochádza&nbsp;k rozhodovaniu na základe
        automatického spracúvania či profilovania.
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        Pokiaľ by ste mali k osobným údajom otázky, kontaktujte nás na
        e-mailovej adrese:&nbsp;
        <a href={`mailto:${contact?.contact.email}`}>
          <strong>{contact?.contact.email}</strong>
        </a>
        &nbsp;alebo tel. č:{" "}
        <a href={`tel:${contact?.contact.mobileConsultancy}`}>
          <strong>{contact?.contact.mobileConsultancy}</strong>
        </a>
        .
      </p>
      <p className="p2">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        <strong>4. Používanie súborov cookies&nbsp;</strong>
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        Súbory cookies plnia rôzne úlohy, napríklad umožňujú efektívnu navigáciu
        medzi webovými stránkami, zapamätanie si Vašich preferencií a celkovo
        zlepšujú skúsenosť používateľa. Dokážu tiež zaistiť, aby reklamy
        zobrazované on-line boli lepšie prispôsobené Vašej osobe a Vašim
        záujmom.
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">Možný výskyt nasledovných cookies:</p>
      <ol className="pt-4 list-decimal pl-6">
        <li className="mb-2">
          <strong>Nevyhnutné cookies</strong>: sú potrebné na prevádzku webových
          stránok, umožňujú napríklad prihlásiť sa do zabezpečených častí
          stránok a ďalšie základné funkčnosti stránok. Táto kategória cookies
          sa nedá zakázať.
        </li>
        <li className="mb-2">
          <strong>Analytické/štatistické cookies</strong>: umožňujú nám
          napríklad rozpoznať a zistiť počet návštevníkov a sledovať, ako naši
          návštevníci používajú webové stránky. Pomáhajú nám zlepšovať spôsob,
          akým stránky fungujú, napríklad tak, že umožňujú používateľom ľahko
          nájsť to, čo hľadajú. Tieto súbory spúšťame iba s Vaším
          predchádzajúcim súhlasom.
        </li>
        <li className="mb-2">
          <strong>Reklamné cookies</strong>: používajú sa na sledovanie
          preferencií a umožňujú zobraziť reklamu a ďalší obsah, ktoré najlepšie
          zodpovedajú vášmu záujmu a online správaniu. Tieto súbory spúšťame iba
          s Vaším predchádzajúcim súhlasom.
        </li>
      </ol>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        Súhlas môže byť vyjadrený prostredníctvom zaškrtávacieho políčka
        obsiahnutého v tzv. cookie lište. Súbory cookies môžete aj následne v
        nastavení svojho internetového prehliadača odmietnuť, alebo si nastaviť
        používanie iba niektorých.
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        <strong>
          5. Vaše práva a&nbsp;povinnosti v&nbsp;oblasti spracovávania Vašich
          osobných údajov:
        </strong>
      </p>
      <p className="mb-0 leading-relaxed">
        <strong>Práva)</strong>
      </p>
      <ol className="pt-4 list-decimal pl-6">
        <li className="mb-2">
          právo na prístup k&nbsp;Vašim údajom, ktoré spracovávame
        </li>
        <li className="mb-2">
          právo na úpravu Vašich osobných údajov, ktoré spracovávame
        </li>
        <li className="mb-2">
          právo na vymazanie Vašich osobných údajov, ktoré spracovávame
        </li>
        <li className="mb-2">
          obmedzenie rozsahu Vašich osobných údajov, ktoré spracovávame
        </li>
        <li className="mb-2">
          namietať rozsah spracovávanie Vašich osobných údajov, ktoré
          spracovávame
        </li>
        <li className="mb-2">
          na presnosť Vašich osobných údajov, ktoré spracovávame
        </li>
        <li className="mb-2">
          na prenos Vašich osobných údajov, ktoré spracovávame
        </li>
        <li className="mb-2">
          podať návrh na začatie konania podľa § 100 Zákona, že je priamo
          dotknutá na svojich právach ustanovených Zákonom
        </li>
        <li className="mb-2">
          odvolať súhlas so spracovávaním Vašich osobných údajov, ktoré
          spracovávame
        </li>
      </ol>
      <p className="mb-0 leading-relaxed">
        <strong>Povinnosti) - spracovávateľ má právo</strong>
      </p>
      <ol className="pt-4 list-decimal pl-6">
        <li className="mb-2">
          právo k&nbsp;prístupu k&nbsp;Vaším osobným údajom v&nbsp;nevyhnutnom
          rozsahu, ktoré spracovávame
        </li>
        <li className="mb-2">
          právo na opravu Vašich osobných údajov, ktoré spracovávame
        </li>
        <li className="mb-2">
          právo na vymazanie Vašich osobných údajov, ktoré spracovávame
        </li>
        <li className="mb-2">
          právo na obmedzenie spracovávania Vašich osobných údajov, ktoré
          spracovávame
        </li>
      </ol>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">
        Ak si myslíte, že s údajmi nezaobchádzame správne, máte právo podať
        sťažnosť dozornému orgánu, ktorým je v našej jurisdikcii,&nbsp;alebo sa
        obrátiť na súd.
      </p>
      <p className="mb-0 leading-relaxed">&nbsp;</p>
      <p className="mb-0 leading-relaxed">Účinnosť od 1.9.2021</p>
    </div>
  );
};

export default PrivacyPolicyPage;
